import React from 'react';
import { useParams } from 'react-router-dom';

import SubjectsRankingTable from '@ts-core/modules/rankings/components/SubjectsRankingTable';
import RankingDatesRangePicker, { useRankingDatesRangePicker } from '../../components/RankingDatesRangePicker';

import { useSubjectsRanking } from '../../hooks';

interface SubjectsRankingPageProps {
  studentsMode?: boolean;
}

const SubjectsRankingPage = (props: SubjectsRankingPageProps) => {
  const { studentsMode } = props;
  const { courseId } = useParams<{ courseId: string }>();

  const { props: rankingDateRangePickerProps, from, to } = useRankingDatesRangePicker();
  const { loading, subjects, students, error, courseName, onRefetchRanking } = useSubjectsRanking({ courseId, from, to });

  return (
    <SubjectsRankingTable
      downloadFileName={courseName}
      getRankingBySubjects={onRefetchRanking}
      students={students}
      subjects={subjects}
      error={error}
      loading={loading}
      studentsMode={studentsMode}
      datesPicker={<RankingDatesRangePicker {...rankingDateRangePickerProps} />}
    />
  );
};

export default SubjectsRankingPage;
